import script from "./Media.vue?vue&type=script&setup=true&lang=js"
export * from "./Media.vue?vue&type=script&setup=true&lang=js"

import "./Media.vue?vue&type=style&index=0&id=203d8649&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203d8649"]])

export default __exports__